import React, { useState, useRef, useEffect } from 'react';
import { signInWithGoogle, signOutUser } from '../services/authService';
import { useAuth } from '../contexts/AuthContext';

const SignInButton = ({ onAdminSettings }) => {
  const { user, isAuthorized, loading } = useAuth();
  const [showDropdown, setShowDropdown] = useState(false);
  const dropdownRef = useRef(null);

  const handleSignIn = async () => {
    try {
      await signInWithGoogle();
    } catch (error) {
      console.error('Sign in failed:', error);
      alert('Sign in failed. Please try again.');
    }
  };

  const handleSignOut = async () => {
    try {
      await signOutUser();
      setShowDropdown(false);
    } catch (error) {
      console.error('Sign out failed:', error);
      alert('Sign out failed. Please try again.');
    }
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setShowDropdown(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  if (loading) {
    return (
      <button className="w-12 h-12 border-none bg-transparent text-text-dark cursor-default flex items-center justify-center">
        <span className="material-icons animate-spin">refresh</span>
      </button>
    );
  }

  if (!user) {
    return (
      <button
        onClick={handleSignIn}
        className="w-12 h-12 border-2 border-accent bg-transparent text-accent cursor-pointer transition-colors duration-200 flex items-center justify-center hover:bg-accent hover:text-white rounded-full"
        title="Sign in"
      >
        <span className="material-icons text-2xl">account_circle</span>
      </button>
    );
  }

  return (
    <div className="relative" ref={dropdownRef}>
      <button
        onClick={() => setShowDropdown(!showDropdown)}
        className="w-12 h-12 border-none bg-transparent cursor-pointer transition-all duration-200 flex items-center justify-center hover:opacity-80 rounded-full"
        title={user.displayName}
      >
        <img 
          src={user.photoURL} 
          alt={user.displayName}
          className="w-12 h-12 rounded-full border-2 border-gray-200"
        />
      </button>

      {showDropdown && (
        <div className="absolute top-full right-0 mt-2 bg-white border border-gray-200 rounded-lg shadow-lg z-10 min-w-[280px] p-4">
          <div className="flex items-center gap-3 mb-3 pb-3 border-b border-gray-100">
            <img 
              src={user.photoURL} 
              alt={user.displayName}
              className="w-10 h-10 rounded-full"
            />
            <div className="flex flex-col">
              <span className="text-sm font-medium text-text-dark">{user.displayName}</span>
              <span className="text-xs text-text-dark/60">{user.email}</span>
              {isAuthorized ? (
                <span className="text-xs text-green-600 font-medium mt-1">Admin</span>
              ) : (
                <span className="text-xs text-text-dark/60 mt-1">Viewer</span>
              )}
            </div>
          </div>
          {isAuthorized && onAdminSettings && (
            <button
              onClick={() => {
                setShowDropdown(false);
                onAdminSettings();
              }}
              className="w-full px-3 py-2 bg-transparent border-none text-text-dark text-sm cursor-pointer transition-colors duration-200 flex items-center gap-2 hover:bg-gray-50 rounded mb-1"
            >
              <span className="material-icons text-base">settings</span>
              Admin Settings
            </button>
          )}
          <button
            onClick={handleSignOut}
            className="w-full px-3 py-2 bg-transparent border-none text-text-dark text-sm cursor-pointer transition-colors duration-200 flex items-center gap-2 hover:bg-gray-50 rounded"
          >
            <span className="material-icons text-base">logout</span>
            Sign Out
          </button>
        </div>
      )}
    </div>
  );
};

export default SignInButton;